import { _ as o } from "./index742.mjs";
import { t as a } from "./index756.mjs";
import { o as e } from "./index757.mjs";
import { f as s } from "./index758.mjs";
var f = o, i = a, t = e, m = s, c = m(function() {
  t(1);
});
f({ target: "Object", stat: !0, forced: c }, {
  keys: function(r) {
    return t(i(r));
  }
});
